<template>
  <div class="content-wrapper">
    <h2 v-if="$route.path.includes('items-selection')" class="page-titles">
      {{ groupOrderDetails.name }}
    </h2>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GroupOrderNew',
  computed: {
    ...mapState({
      loadGroupOrder: state => state.groupOrder.loadGroupOrder,
      groupOrderDetails: state => state.groupOrder.groupOrderDetails
    })
  }
}
</script>

<style lang="scss" scoped></style>
